import { initializeApp } from "firebase/app";
import {
  getFirestore,
  serverTimestamp,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyABphLTqqP0kyu_T1eKhq5Egj0bvL-ajdM",
  authDomain: "lehameaudusorbier.firebaseapp.com",
  projectId: "lehameaudusorbier",
  storageBucket: "lehameaudusorbier.firebasestorage.app",
  messagingSenderId: "364534375927",
  appId: "1:364534375927:web:670d387aafeab2c11a7af2",
  measurementId: "G-BNZ8HHR4DJ"
};


const app = initializeApp(firebaseConfig);

// ✅ Expose Firestore et Auth (pas d'Analytics ici)
export const db = getFirestore(app);
export const auth = getAuth(app);

// --- Helpers utilisés par ton site ---
export async function saveMessage(data) {
  const id =
    (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
    `msg_${Date.now()}_${Math.random().toString(16).slice(2)}`;

  await setDoc(doc(db, "messages", id), {
    ...data,
    status: "new", // new | read | archived
    createdAt: serverTimestamp(),
  });
  return id;
}

export async function setMessageStatus(id, status) {
  await updateDoc(doc(db, "messages", id), { status });
}

export async function removeMessage(id) {
  await deleteDoc(doc(db, "messages", id));
}

export async function getMessage(id) {
  const snap = await getDoc(doc(db, "messages", id));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}